module.exports = __webpack_public_path__ + "img/logo.223a10d8.svg";